const getDefaultState = () => {
  return {
    version: 'VK 0.3.0',
  }
}

const state = getDefaultState()

const getters = {}

const actions = {

}

const mutations = {

};

export default {
  state,
  getters,
  actions,
  mutations
}
